module.exports = __webpack_public_path__ + "img/logo_csp.d11d2503.png";